export default __webpack_public_path__ + "static/media/switch-camera.31214af2.svg";